module.exports = __webpack_public_path__ + "static/media/W7@1.5x.2fc4d4cf.png";